import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import CustomPagination from '../../common/CustomPagination';
import HistoryCustomPagination from './HistoryCustomPagination';
import moment from 'moment';

const UnlockHistory = ({ isHistoryOpen, setIsHistoryOpen, historyHeaders, historySearch, setHistorySearch, historyApi, }) => {
    const payoutReducer = useSelector((state) => state?.PayoutReducer);
    const globalReducer = useSelector((state) => state?.globalReducer);
    useEffect(()=>{
        console.log("payoutReducer?.getHistory",payoutReducer?.getHistory)
    },[payoutReducer?.getHistory])
    return (
        <>
            <div className="d-flex justify-content-between border-bottom modalHeader">
                <h4 className="font-bold text-black">History Log</h4>
                <button
                    type="button"
                    className="btn-close history-close"
                    aria-label="Close"
                    onClick={() => setIsHistoryOpen(false)}
                ></button>
            </div>
            <div className="modal-body">
                <div className="table-responsive __custom__properties">
                    <table className="table">
                        <thead>
                            <tr>
                                {historyHeaders?.map((i) => {
                                    return (<th scope="col">{i?.label}</th>)
                                })}

                            </tr>
                        </thead>
                        <tbody>
                            {payoutReducer?.getHistory?.map((item, index) => {
                                return (
                                    <tr>
                                       
                                        {historyHeaders?.filter((ele) => ele?.show === true)?.map((coll) => {
                                            return (

                                                <td>
                                                    {coll?.type === "date" ? moment(item[coll?.col] ).format("LLL"): item[coll?.col]}
                                                </td>

                                            );
                                        })}
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-between">
            <div className="pagination-row">
              {globalReducer?.getTotalHistoryRow !== 0 && (
                <HistoryCustomPagination
                  totalCount={globalReducer?.getTotalHistoryRow}
                  perPageData={historySearch?.rows}
                  searchFilter={historySearch}
                  setSearchFilter={setHistorySearch}
                  apiCall={historyApi}
                 
                />
              )}
            </div>
          </div>
            </div>
        </>
    )
}

export default UnlockHistory